<div class="tw-border-mercury-200 tw-items-center tw-flex tw-justify-between md:tw-bg-white"
  [class.tw-w-full]="kind === 'full'" [ngClass]="{'tw-border tw-border-[#E3E3E3] tw-rounded-lg' : fromActivityLog}">
  <div class="tw-flex tw-items-center  tw-leading-6 {{ kind === 'full' ? 'tw-w-full tw-bg-[#F2F2F2]' : '' }}"
    [ngClass]="variation === 'default' ? 'tw-text-lg tw-gap-4 tablet:tw-gap-5' : 'tw-text-sm tw-bg-grey-150 tw-rounded-lg'">
      <a  [class.tw-w-full]="kind === 'full'" *ngFor="let tab of tabs; let index = index " [routerLink]="switchTab ? tab.link : null" (click)="switchTab && onTabClick(tab.key)" class="tw-cursor-pointer tw-transition-all">
      <div *ngIf="variation === 'default'" class="tw-flex tw-flex-col tw-gap-2.5 tablet:tw-gap-3 tw-items-center" [class.tw-w-full]="kind === 'full'">
        <div [ngClass]="[getTabClasses(tab.key), !switchTab ? 'tw-cursor-not-allowed' : '']" class="{{ kind === 'full' ? 'tw-w-full tw-justify-center' : '' }}">
          {{ tab.title }}
          {{ tab.mediaLength !== 0 ? '(' + tab.mediaLength + ')' : '' }}

          <ng-container *ngTemplateOutlet="howToTemplate; context: { $implicit: tab }" ></ng-container>

        </div>        
        <div [ngClass]="activeTab === tab.key ? 'tw-h-[2px] tw-bg-primary-700 tw-w-full tw-bottom-[-1px] tw-relative' : 'tw-hidden' "></div>
      </div>

      <div *ngIf="variation === 'filled'" class="tw-flex tw-items-center" [class.tw-w-full]="kind === 'full'">
        <div [ngClass]="customclassesForTab ?  getCustomClass(tab.key,index) : getTabClasses(tab.key)"
        class="tw-flex tw-items-center tw-gap-1 tw-min-h-10 tw-transition-all {{ kind === 'full' ? 'tw-w-full tw-justify-center' : '' }} ">
          <i-icon *ngIf="tab.icon" [name]="tab.icon" [height]="'tw-h-4'" [width]="'tw-w-4'"></i-icon>
          <span class="tw-whitespace-nowrap">{{ tab.title }}</span>
          <span *ngIf="tab.mediaLength !== 0">({{ tab.mediaLength }})</span>

          <ng-container *ngTemplateOutlet="howToTemplate; context: { $implicit: tab }" ></ng-container>
        </div>
      </div>
      
    </a>
  </div>
  <div class="tw-flex right-area">
    <ng-content></ng-content>
  </div>
</div>

<ng-template #howToTemplate let-tab>
  @if(tab.howToId && tab.key === activeTab && (this.authState.auth?.isAuthenticated$ | async)){
    <span
      (click)="showHowTo($event, tab.howToId)"
      [tabindex]="tab.howToId"
      (keyup.click)="showHowTo($event, tab.howToId)"
      role="button"
      class="tw-inline-block">
      <i-icon name="question" class="tw-w-[18px] tw-h-[18px] tw-text-grey-750 !tw-block"></i-icon>
    </span>
  }
</ng-template>

<!-- Apply Filter Modal -->
@if (howtoModal()) {
  <sml-how-to [howtoData]="howtoData()" (hideModal)="closeModal()" />
}
<!-- END -->